<div
  class="tw-sticky tw-top-0 tw-z-40 dark:tw-bg-dark-500 tw-bg-gray-100 tw-py-5 tw-px-5 tw-flex tw-justify-between tw-items-center"
>
  <span
    *ngIf="!hasContent"
    class="dark:tw-text-white tw-font-medium tw-text-xl"
  >
    {{ title }}
  </span>

  <div #headerContent>
    <ng-content select="[header-content]"></ng-content>
  </div>

  <i
    *ngIf="isShowClose" 
    class="mdi mdi-close !tw-text-red-500 dark:text-danger tw-text-2xl tw-cursor-pointer ignore-dark-color"
    [matTooltip]="'common.close' | translate"
    (click)="onClose()"
  ></i>
</div>
